import React from 'react';
import { motion } from 'framer-motion';
import {
  Building,
  Home,
  MapPin,
  Search,
  ArrowRight,
  Calendar,
  Clock,
  Users
} from 'lucide-react';

const HeroSection = () => {
    return (
      <section className="relative h-[820px] overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2670&auto=format&fit=crop" 
            alt="Luxury Property" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent dark:from-black/90 dark:via-black/70 dark:to-black/30"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10 h-full flex items-center">
          <div className="max-w-3xl">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="inline-flex items-center px-4 py-2 bg-amber-500/90 dark:bg-amber-600/90 text-white rounded-full font-medium text-sm mb-6 backdrop-blur-sm">
                <Building size={12} className="mr-2" />
                <span>Premium Real Estate Collection</span>
              </div>
              
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
                Luxury Living in <span className="text-blue-400 dark:text-blue-300">Himachal Pradesh</span>
              </h1>
              
              <div className="w-24 h-1 bg-blue-500 dark:bg-blue-400 mb-8"></div>
              
              <p className="text-xl text-gray-100 mb-12 max-w-2xl leading-relaxed">
                Experience unparalleled luxury in the picturesque landscapes of Himachal Pradesh with Dev Bhoomi Group's exclusive collection of premium properties.
              </p>
              
              <div className="flex flex-wrap gap-4">
                <motion.a 
                  href="#properties" 
                  className="inline-flex items-center px-8 py-4 bg-blue-900/60 dark:bg-blue-800/70 text-white border border-white/30 rounded-lg backdrop-blur-sm hover:bg-blue-900/90 dark:hover:bg-blue-800/90 transition-all duration-300"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span>Explore Properties</span>
                  <ArrowRight size={18} className="ml-2" />
                </motion.a>
                
                <motion.a 
                  href="#contact" 
                  className="inline-flex items-center px-8 py-4 bg-white/10 dark:bg-white/5 text-white border border-white/30 rounded-lg backdrop-blur-sm hover:bg-white/20 dark:hover:bg-white/15 transition-all duration-300"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span>Schedule a Viewing</span>
                  <Calendar size={18} className="ml-2" />
                </motion.a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    );
  };

export default HeroSection;